import { EnrichedAssignmentMetricsByWorkload } from '@/pages/OperationsInsights/types/AssignmentMetricsResponseEnriched';

/**
 * Transform Grid Data for - Total Assignments By Workload
 *
 * @param metrics
 */
export const tfGdAssignmentTotalByWorkload = (metrics: EnrichedAssignmentMetricsByWorkload[]) => {
    const gridMap = new Map<number, object>();
    for (const assignmentMetric of metrics) {
        // Change represents the total number of workload assignments added to / removed from Open Assignments during the reporting period, grouped by workload.
        // const changes = assignmentMetric.completedCount ? roundToOneDecimal(assignmentMetric.assignments / assignmentMetric.completedCount) : 0;
        // New rule [PVDEV-728] `changes = Open EoP - Open BoP`
        const openCountBoP = assignmentMetric.openCountBoP ?? 0;
        const openCountEoP = assignmentMetric.openCountEoP ?? 0;
        const changes = openCountEoP - openCountBoP;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const row: any = {
            name: assignmentMetric.name,
            assignments: assignmentMetric.assignments,
            completedWithinSLA: assignmentMetric.completedWithinSLA,
            completedBreached: assignmentMetric.completedBreached,
            openCountEoP: assignmentMetric.openCountEoP,
            changes
        };
        gridMap.set(assignmentMetric.workloadId, row);
    }
    return Array.from(gridMap.values());
};

/**
 * Colum Definition for Total Assignments By Workload
 */
export const getTotalAssignmentsByWorkloadColumnDefs = () => {
    return [
        {
            field: 'name', headerName: 'Workload', minWidth: 220, filter: true
        },
        {
            field: 'assignments', headerName: 'Created Assignments', flex: 2, filter: true
        },
        {
            field: 'completedWithinSLA', headerName: 'Completed Within SLA', flex: 2, filter: true
        },
        {
            field: 'completedBreached', headerName: 'Completed Breached', flex: 2, filter: true
        },
        {
            field: 'openCountEoP', headerName: 'Open Assignments', filter: true
        },
        {
            field: 'changes', headerName: 'Change', filter: true
        }

    ];
};